import { ElementType } from "@easy-email-pro-core/constants";
import { StandardGroup } from "./Group";
import { StandardSection } from "./Section";
import { StandardColumn } from "./Column";
import { StandardButton } from "./Button";
import { StandardImage } from "./Image";
import { StandardSpacer } from "./Spacer";
import { StandardNavbar } from "./Navbar";

import {
  StandardHeading1,
  StandardHeading2,
  StandardHeading3,
  StandardHeading4,
  StandardParagraph,
  StandardText,
} from "./Text";
import { StandardTextList, StandardTextListItem } from "./TextList";
import { StandardWrapper } from "./Wrapper";

import { StandardDivider } from "./Divider";
import { StandardSocial } from "./Social";
import { StandardHero } from "./Hero";
import { StandardSocialElement } from "./SocialElement";
import { StandardNavbarLink } from "./NavbarLink";
import { StandardBlockquote } from "./Blockquote";
import { StandardTable } from "./Table";
import { StandardTable2 } from "./Table2";
import { StandardTable2Tr } from "./Table2/Table2Tr";
import { StandardTable2Td } from "./Table2/Table2Td";

export default {
  [ElementType.STANDARD_HERO]: StandardHero,
  [ElementType.STANDARD_DIVIDER]: StandardDivider,
  [ElementType.STANDARD_WRAPPER]: StandardWrapper,
  [ElementType.STANDARD_SECTION]: StandardSection,
  [ElementType.STANDARD_GROUP]: StandardGroup,
  [ElementType.STANDARD_SOCIAL]: StandardSocial,
  [ElementType.STANDARD_SOCIAL_ELEMENT]: StandardSocialElement,
  [ElementType.STANDARD_COLUMN]: StandardColumn,
  [ElementType.STANDARD_BUTTON]: StandardButton,
  [ElementType.STANDARD_SPACER]: StandardSpacer,
  [ElementType.STANDARD_IMAGE]: StandardImage,
  [ElementType.STANDARD_TEXT]: StandardText,
  [ElementType.STANDARD_NAVBAR]: StandardNavbar,
  [ElementType.STANDARD_NAVBAR_LINK]: StandardNavbarLink,
  [ElementType.STANDARD_PARAGRAPH]: StandardParagraph,
  [ElementType.STANDARD_H1]: StandardHeading1,
  [ElementType.STANDARD_H2]: StandardHeading2,
  [ElementType.STANDARD_H3]: StandardHeading3,
  [ElementType.STANDARD_H4]: StandardHeading4,
  [ElementType.STANDARD_TABLE]: StandardTable,
  [ElementType.STANDARD_TEXT_LIST]: StandardTextList,
  [ElementType.STANDARD_TEXT_LIST_ITEM]: StandardTextListItem,
  [ElementType.STANDARD_BLOCK_QUOTE]: StandardBlockquote,
  [ElementType.STANDARD_TABLE2]: StandardTable2,
  [ElementType.STANDARD_TABLE2_TR]: StandardTable2Tr,
  [ElementType.STANDARD_TABLE2_TD]: StandardTable2Td,
};
